import { useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import { KeenIcon } from '@/components';
import { toAbsoluteUrl } from '@/utils';

const CreateInvoiceTemplate = () => {
    const { values, setFieldValue } = useFormikContext();
    const theme = JSON.parse(localStorage.getItem('settings-configs'));
    const staticTemplates = [
        { id: '1', name: 'matter', label: 'Matter', imageLight: 'classic-invoice-style-black.png', disabled: false },
        { id: '2', name: 'classic', label: 'Classic', imageLight: 'matter-invoice-style-black.png', disabled: false },
        // { id: '3', name: 'lava', label: 'Lava', imageLight: 'template-clover-light.png', disabled: false },
        { id: '4', name: 'lava', label: 'Lava', imageLight: 'lava-invoice-style-black.png', disabled: false },
    ];

    const renderItem = (item) => (
        <div key={item.id} className="invoice-template-wrapper group">
            <label
            className={`
                ${item.disabled ? 'opacity-50 !cursor-not-allowed' : ''}
                cursor-pointer invoice-template-preview
                flex items-end border bg-no-repeat bg-cover bg-top
                border-gray-300 dark:border-gray-200 rounded-xl
                has-[:checked]:!border-success has-[:checked]:border-2 [&_.checked]:has-[:checked]:flex
                h-[250px] mb-1
            `}
            style={{
                backgroundImage: `url(${toAbsoluteUrl(`/media/illustrations/${
                    item.imageLight
                }`)})`,
                // theme.themeMode === 'dark' ? item.imageDark : item.imageLight
            }}
            >
            <input
                type="radio"
                name="invoice_template_settings.invoice_theme.theme"
                value={item.name}
                checked={values.invoice_template_settings.invoice_theme.theme === item.name}
                onChange={() => setFieldValue('invoice_template_settings.invoice_theme.theme', item.name)}
                className="appearance-none"
                disabled={item.disabled}
            />
            <KeenIcon
                icon="check-circle"
                className="checked ms-5 mb-5 text-xl text-success leading-none hidden"
                style="solid"
            />
            </label>

            <div className='flex items-center justify-between mt-1.5'>
            <span className="text-sm font-medium text-gray-900 dark:text-white">Theme: {item.label}</span>
            <a
                href={`${toAbsoluteUrl(`/media/illustrations/${
                    item.imageLight
                }`)}`}
                // theme.themeMode === 'dark' ? item.imageDark : item.imageLight
                target="_blank"
                className="btn-link !leading-3"
            >
                Preview Template
            </a>
            </div>
        </div>
    );

    return (
        <>
        <div className='flex items-center my-5'>
            <span className='w-1/2 h-0.5 border border-dashed inline-block'></span>
            <p className='text-sm shrink-0 w-fit px-4'>Choose Invoice Template</p>
            <span className='w-1/2 h-0.5 border border-dashed inline-block'></span>
        </div>
        <div className='grid lg:grid-cols-3 sm:grid-cols-2 gap-5'>
            {staticTemplates.map(renderItem)}
        </div>
        </>
    )
}

export { CreateInvoiceTemplate }